import { retime, conflicts } from './scheduleTimeline';
// Shooting Schedule time helpers (frontend mirror of backend/src/lib/shooting-schedule.js).
// Times are 'HH:MM' 24h day-local; entries may run past midnight (night shoots).

const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/;
export const isTime = t => TIME_RE.test(String(t || ''));
export const toMin = t => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
export const toTime = m => `${String(Math.floor(m / 60) % 24).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
export const fmtMin = m => { const h = Math.floor(m / 60); const r = m % 60; return h ? (r ? `${h}h ${r}m` : `${h}h`) : `${r}m`; };

// Sequential starts: unlocked entries begin when the previous ends; locked entries keep their
// time and are flagged as a conflict when they start before the previous entry finishes.
export const recalcTimes = (entries, dayStart = '08:00') => {
  const out = retime(entries, dayStart);
  return { entries: out, conflicts: conflicts(out) };
};
export const detectConflicts = entries => conflicts(entries);

export const dayTotals = (entries, eighthsByUid = new Map()) => {
  let totalMin = 0; let totalEighths = 0;
  for (const e of entries) {
    totalMin += e.durationMin || 0;
    if (e.kind === 'scene') {
      const length = eighthsByUid.get(e.sceneUid);
      if (!Number.isInteger(length)) totalEighths = null;
      else if (totalEighths != null) totalEighths += length;
    }
  }
  return { totalMin, totalEighths };
};

export const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `e${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`);

// Meal breaks are never locked: the First AD can always move and edit Breakfast, Lunch and
// Dinner Breaks. Other entries keep the existing explicit lock behaviour.
const MEAL_TYPES = new Set(['BREAKFAST', 'LUNCH', 'DINNER']);
export const isMealBreak = e => e?.kind === 'activity' && MEAL_TYPES.has(e?.activityType);

// '2026-11-02' -> 'Monday 2 November'
export const fmtDate = d => {
  if (!d) return 'No date';
  try { return new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' }); } catch (_) { return d; }
};
export const fmtDateShort = d => {
  if (!d) return '';
  try { return new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (_) { return d; }
};
